const DOCUMENTATION = {
    API: {
        queryKey: 'getApiDocumentation',
        url: '/users/apiDocumentation'
    },
    USER_GUIDE: {
        queryKey: 'getUserGuideDocumentation',
        url: '/users/portalDocumentation'
    },
    MERCHANT_GUIDE: {
        queryKey: 'getUserMerchantGuideDocumentation',
        url: '/users/portalMerchantDocumentation'
    },
    PAYLUDD_INIT_GUIDE: {
        queryKey: 'getPayluddInitGuideDocumentation',
        url: '/users/payluddDocumentation'
    },
    MERCHANT_PAYLUDD_GUIDE: {
        queryKey: 'getPayluddMerchantGuideDocumentation',
        url: '/users/payluddMerchantDocumentation'
    }
};
export default DOCUMENTATION;